import React, { useEffect, useRef, useState } from 'react';
import styles from './ProductsSearchedView.module.scss';
import * as getProductsSearchedService from './services/get-products-search.service';
import { ProductPaginated } from './models/product-paginated.model';
import Paginator from '../../../../shared/paginator/Paginator';
import ProductCard from '../../../../shared/product-card/ProductCard';
import { Product } from '../../models';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import ProductsNavigation from '../products-navigation/ProductsNavigation';

export default function ProductsSearchedView(props: any) {
    const filters = useSelector((state: RootState) => state.filters);

    const [productsObject, setProductsObject] = useState<ProductPaginated | null>();
    const [currentPage, setCurrentPage] = useState(0);
    const [perPage, setPerPage] = useState(20);
    const main_container_ref = useRef<any>(null);

    useEffect(() => {
        const pickupPointId = localStorage.getItem("pickupPointsFilter");
        if (pickupPointId !== null) {
            filters.pickupPointId = pickupPointId;
        }
        getProductsSearchedService.getProductsSearchModel(currentPage + 1, perPage, filters).then((response: any) => {
            let result = response.data as ProductPaginated;
            setProductsObject(result);
        })
    }, [filters, currentPage, perPage]);

    useEffect(() => {
        setProductsObject(null)
        setCurrentPage(0);
    }, [props.selectedCategory])

    const handlePageClick = (selectedPage: any) => {
        setCurrentPage(selectedPage.selected);
        main_container_ref?.current.scrollIntoView();
    };

    const handlePerPageChange = (event: any) => {
        setPerPage(parseInt(event.target.value));
        setCurrentPage(0);
    };

    const handleCartItemsChange = () => {
        props.onCartItemsChange();
    }

    return (
        <div className={styles.main_container} ref={main_container_ref}>
            <ProductsNavigation />
            <div className={styles.cards_container}>
                {productsObject?.items && productsObject?.items?.map((product: Product, index: number) => (
                    <ProductCard key={product.id} product={product} onCartItemsChange={handleCartItemsChange} />
                ))}
            </div>
            <div className={styles.paginator_container}>
                {
                    productsObject &&
                    <Paginator
                        perPage={perPage}
                        onPageClick={handlePageClick}
                        onPerPageChange={handlePerPageChange}
                        currentPage={currentPage ? currentPage : 0}
                        totalPages={productsObject ? productsObject?.totalPages as number : 0} />
                }
            </div>
        </div>
    )
}
